// extracted by mini-css-extract-plugin
module.exports = {"formWrapper":"Input_formWrapper__11pow","formControl":"Input_formControl__3AqAS","formLabel":"Input_formLabel__1TyBK","inputWrapper":"Input_inputWrapper__2Ej9B"};